export const SWITCH_VARIANT_DEFAULT = 'default';
export const SWITCH_VARIANT_WITH_ICON = 'withIcon';
//# sourceMappingURL=constants.js.map